<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

defineProps({
  title: { type: String, required: true },
  meta: { type: String, required: true },
  category: { type: String, default: '' },
});

const router = useRouter();
const { t } = useI18n();
</script>

<template>
  <div class="search-page-heading">
    <button type="button" class="search-page-heading__back" :aria-label="t('search.back')" @click="router.back()">←</button>
    <div>
      <p class="search-page-heading__crumbs">
        {{ t('search.pageTitle') }}
        <template v-if="category">
          › <b>{{ category }}</b>
        </template>
      </p>
      <h1 class="search-page-heading__title">{{ title }}</h1>
      <p class="search-page-heading__meta">{{ meta }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.search-page-heading {
  display: flex;
  align-items: center;
  gap: 14px;

  &__back {
    display: grid;
    flex-shrink: 0;
    place-items: center;
    width: 36px;
    height: 36px;
    border: 1px solid $black80;
    border-radius: 4px;
    background: $black30;
    color: $white;
    font-size: 1.1rem;
    cursor: pointer;

    &:hover,
    &:focus-visible {
      border-color: $white;
    }
  }

  &__crumbs {
    margin: 0 0 2px;
    font-size: 0.75rem;
    color: $gray50;

    b {
      color: $light-gray;
      font-weight: 600;
    }
  }

  &__title {
    margin: 0;
    font-size: 1.75rem;
    font-weight: 700;
    color: $white;

    @include mobile-sm-max {
      font-size: 1.35rem;
    }
  }

  &__meta {
    margin: 4px 0 0;
    font-size: 0.8rem;
    color: $light-gray;
  }
}
</style>
